// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__9f1hj","header":"ClearentDisclaimer_header__2hv1n","inner":"ClearentDisclaimer_inner__2GYng"};